// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupNichesForm .buttonsSection {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 8px;
}
.GroupNichesForm h2 {
  margin-bottom: 12px;
}
.GroupNichesForm .GroupNichesForm-nicheTitles {
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/group-niches-form/group-niches-form.styles.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,mBAAA;AAFJ","sourcesContent":[".GroupNichesForm {\n  .buttonsSection {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 8px;\n  }\n\n  h2 {\n    margin-bottom: 12px;\n  }\n\n  .GroupNichesForm-nicheTitles {\n    margin-bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
